export default {
  components: {},
  data() {
    return {
      pro: '',
      replace_pro: '',
      radioValue: '2',
      btnConfig: {
        typeAll: 'default', // 按钮统一风格样式
        btnsite: 'right', // 按钮位置 (right , center , left)
        buttons: [
          {
            text: t('取消'),
            btnclick: () => {
              this.$parent.$parent.closeConfirm()
            }, // 按钮点击事件
          },
          {
            type: 'primary', // 按钮类型
            text: t('确定'),
            btnclick: () => {
              this.confirm()
            },
          },
        ],
      },
      proName: '',
      replace_proName: '',
      tableConfig: {
        businessFormConfig: {
          formValue: {
            searchValue: '',
            psCProEcode: '',
            proName: "",
          },
          formData: [
            {
              label: t('商品SKU'), // '商品SKU',
              style: 'dimSearch',
              width: '12',
              value: 'searchValue',
              columns: ['ECODE'],
              AuotData: [], // 匹配的选项
              dimChange: async (val) => {
                this.handleDimChange('tableConfig', 'searchValue', val)
              },
              dimEnter: () => {
                this.search('one')
              },
              dimSelect: (val) => {
                this.tableConfig.businessFormConfig.formValue.searchValue = val.label
              },
            },
            {
              label: t('商品款号'), // '商品款号',
              style: 'dimSearch',
              width: '12',
              value: 'psCProEcode',
              columns: ['ECODE'],
              AuotData: [], // 匹配的选项
              dimChange: async (val) => {
                this.handleDimChange('tableConfig', 'psCProEcode', val)
              },
              dimEnter: () => {
                this.tableConfig.current = 1
                this.search('one')
              },
              dimSelect: (val) => {
                this.tableConfig.businessFormConfig.formValue.psCProEcode = val.label
                // this.psCProEcode = val.label;
              },
            },
            {
              label: t('SPU名称'),
              style: 'dimSearch',
              width: '12',
              value: 'proName',
              columns: ['ECODE'],
              AuotData: [], // 匹配的选项
              dimChange: async (val) => {

              },
              dimEnter: () => {
                this.tableConfig.current = 1
                this.search('one')
              },
              dimSelect: (val) => {
                this.tableConfig.businessFormConfig.formValue.proName = val.label
                // this.psCProEcode = val.label;
              },
            },
          ],
        },
        // searchBtn
        businessButtonConfig: {
          typeAll: 'default', // 按钮统一风格样式
          btnsite: 'right', // 按钮位置 (right , center , left)
          buttons: [
            {
              text: t('搜索'),
              type: "primary",
              btnclick: () => {
                this.fnsearch('one')
              }, // 按钮点击事件
            },
          ],
        },
        indexColumn: true,
        isShowSelection: true,
        columns: [
          // {
          //   key: 'index',
          //   title: '序号',
          // },
          // {
          //   key: 'skuEcode',
          //   title: t('条码'),
          // },
          // {
          //   key: 'spuEcode',
          //   title: t('SPU编码'),
          // },
          // {
          //   key: 'spuEname',
          //   title: t('SPU名称'),
          // },
          // {
          //   key: 'skuEname',
          //   title: t('SKU名称'), // SKU名称
          // },
          // {
          //   key: 'brandEname',
          //   title: t('品牌'),
          // },
          // {
          //   key: 'classifyEname',
          //   title: t('商品分类'),
          // },
          {
            title: t('商品SKU'),
            key: 'ECODE',
          },
          {
            title: t('SPU名称'),
            key: 'PS_C_PRO_ENAME',
          },
          {
            title: t('商品SKU名称'),
            key: 'SPEC',
          },
        ],
        data: [],
        pageShow: false, // 控制分页是否显示
        btnsShow: true, // 控制操作按钮是否显示
        searchInputShow: false, // 控制搜索框是否显示
        width: '', // 表格宽度
        height: '290', // 表格高度
        border: true, // 是否显示纵向边框
        total: 0, // 设置总条数
        pageSizeOpts: [10, 20, 30, 50, 100], // 每页条数切换的配置
        current: 1,
        pageSize: 10, // 每页条数
        multiple: false,
        highlightRow: true,
      },
      tableConfig2: {
        businessFormConfig: {
          formValue: {
            searchValue: '',
            psCProEcode: '',
            proName: ""
          },
          formData: [
            {
              label: t('商品SKU'), // '商品SKU',
              style: 'dimSearch',
              width: '12',
              value: 'searchValue',
              columns: ['ECODE'],
              AuotData: [], // 匹配的选项
              dimChange: async (val) => {
                this.handleDimChange('tableConfig2', 'searchValue', val)
              },
              dimEnter: () => {
                this.tableConfig2.current2 = 1
                this.search('two')
              },
              dimSelect: (val) => {
                this.tableConfig2.businessFormConfig.formValue.searchValue = val.label
              },
            },
            {
              label: t('商品款号'), // '商品款号',
              style: 'dimSearch',
              width: '12',
              value: 'psCProEcode',
              columns: ['ECODE'],
              AuotData: [], // 匹配的选项
              dimChange: async (val) => {
                this.handleDimChange('tableConfig2', 'psCProEcode', val)
              },
              dimEnter: () => {
                this.search('two')
              },
              dimSelect: (val) => {
                this.tableConfig2.businessFormConfig.formValue.psCProEcode = val.label
                // this.psCProEcode = val.label;
              },
            },
            {
              label: t('SPU名称'),
              style: 'dimSearch',
              width: '12',
              value: 'proName',
              columns: ['ECODE'],
              AuotData: [], // 匹配的选项
              dimChange: async (val) => {

              },
              dimEnter: () => {
                this.tableConfig.current = 1
                this.search('two')
              },
              dimSelect: (val) => {
                this.tableConfig.businessFormConfig.formValue.proName = val.label
                // this.psCProEcode = val.label;
              },
            },
          ],
        },
        // searchBtn
        businessButtonConfig: {
          typeAll: 'default', // 按钮统一风格样式
          btnsite: 'right', // 按钮位置 (right , center , left)
          buttons: [
            {
              text: t('搜索'),
              type: "primary",
              btnclick: () => {
                this.fnsearch('two')
              }, // 按钮点击事件
            },
          ],
        },
        current: 1,
        indexColumn: true,
        isShowSelection: true,
        columns: [
          // {
          //   key: 'index',
          //   title: '序号',
          // },
          // {
          //   key: 'skuEcode',
          //   title: t('条码'),
          // },
          // {
          //   key: 'spuEcode',
          //   title: t('SPU编码'),
          // },
          // {
          //   key: 'spuEname',
          //   title: t('SPU名称'),
          // },
          // {
          //   key: 'skuEname',
          //   title: t('SKU名称'), // SKU名称
          // },
          // {
          //   key: 'brandEname',
          //   title: '品牌',
          // },
          // {
          //   key: 'classifyEname',
          //   title: '商品分类',
          // },
          {
            title: t('商品SKU'),
            key: 'ECODE',
          },
          {
            title: t('SPU名称'),
            key: 'PS_C_PRO_ENAME',
          },
          {
            title: t('商品SKU名称'),
            key: 'SPEC',
          },
        ],
        data: [],
        pageShow: false, // 控制分页是否显示
        btnsShow: true, // 控制操作按钮是否显示
        searchInputShow: false, // 控制搜索框是否显示
        width: '', // 表格宽度
        height: '290', // 表格高度
        border: true, // 是否显示纵向边框
        total: 0, // 设置总条数
        pageSizeOpts: [10, 20, 30, 50, 100], // 每页条数切换的配置
        pageSize: 10, // 每页条数
        multiple: false,
        highlightRow: true,
      },
      replaceTableLoad: false,
      tableLoad: false,
      data: [],
      replace_data: [],
      onRowClickReplaceData: {},
      onRowClickData: {},
      onRowClickText: '',
      onRowClickReplaceText: '',

    }
  },
  props: {
    componentData: {
      type: Object,
    },
  },
  methods: {
    // 选中某一项时触发
    onSelect1(v) {
      //  this.skuEcodes = v[0].skuEcode
      console.log(v)
      console.log('----111')
    },
    // 取消选中某一项时触发
    onSelectCancel1() { },
    // 点击全选时触发
    onSelectAll1() { },
    // 点击取消全选时触发
    onSelectAllCancel1() { },
    // 单击某一行时触发
    onRowClick1(row) {
      console.log(row)
      this.onRowClickText = row.skuEcode
      this.skuEcodes = row.skuEcode
      this.onRowData = row
      this.onRowClickData = row
    },
    // 单击某二行时触发
    onRowDblclick1() { },
    // 分页change 事件
    pageChange1(val) {
      this.tableConfig.current = val
      // this.request(this.componentData);
      this.search('one')
    },
    // 切换分页条数
    pageSizeChange1(val) {
      this.tableConfig.pageSize = val
      this.search('one')
      // this.request(this.componentData);
    },
    tableDeleteDetail1() { },
    onSelect2(v) {
      //  this.skuEcodes = v[0].skuEcode
      console.log(v)
      console.log('----111')
    },
    // 取消选中某一项时触发
    onSelectCancel2() { },
    // 点击全选时触发
    onSelectAll2() { },
    // 点击取消全选时触发
    onSelectAllCancel2() { },
    // 单击某一行时触发
    onRowClick2(row) {
      console.log(row)
      this.onRowClickReplaceText = row.skuEcode
      this.skuEcodes2 = row.skuEcode
      this.onRowData2 = row
      this.onRowClickReplaceData = row
    },
    // 单击某二行时触发
    onRowDblclick2() { },
    // 分页change 事件
    pageChange2(val) {
      this.tableConfig2.current = val
      this.search('two')
    },
    // 切换分页条数
    pageSizeChange2(val) {
      this.tableConfig2.pageSize = val
      this.search('two')
    },
    tableDeleteDetail2() { },
    radioChange(value) {
      console.log(value)
    },
    // 模糊查询的方法
    async handleDimChange (formName, fieldName, val) {
      const _this = this;
      switch (fieldName) {
        case 'searchValue':
          _this[formName].businessFormConfig.formValue[fieldName] = val.trim();
          const query = {
            isBlur: 'Y', // N为精确匹配
            psCSku: {
              ECODE: val.trim(),
            },
          };
          let res = await _this.service.common.skuQuery(query);
          if (res.status === 200) {
            const data = res.data.data.data;
            let dimList = _this[formName].businessFormConfig.formData;
            let arr;
            data.map((item) => {
              // 删除不需要展示的模糊搜索项
              delete item.GBCODE;
              delete item.IS_GIFT;
              delete item.IS_GROUP;
              delete item.PRICELIST;
              // delete item.PS_C_PRO_ECODE;
              delete item.PS_C_PRO_ID;
              delete item.colorId;
              delete item.colorName;
              delete item.sizeId;
              delete item.sizeName;
              delete item.skuId;
            });
            dimList.map((item) => {
              // '商品SKU'
              if (item.label === t('商品SKU')) {
                item.AuotData = data;
                // 调用查询提取方法,传给条码,默认数量为一,调用状态为0的保存接口
              }
            });
          }
          break;
        case 'psCProEcode':
          _this[formName].businessFormConfig.formValue[fieldName] = val.trim();
          const fromdata = new FormData();
          const params = {
            GLOBAL: val.trim(),
            PAGENUM: 1,
            PAGESIZE: 10,
            CONDITION: {},
            TABLENAME: 'PS_C_PRO',
          };
          fromdata.append('param', JSON.stringify(params));
          const { data: { code, data }} = await this.service.common.screenresult(fromdata);
          if (code === 0) {
            let arrs = _this[formName].businessFormConfig.formData;

            arrs.map((item) => {
              // '商品款号'
              if (item.label === t('商品款号')) {
                item.AuotData = data.list;
              }
            });
          }
          break;

        default:
          break;
      }
    },
    fnsearch(val) {
      if (val == 'one') {
        this.tableConfig.current = 1
        this.onRowClickText = ''
        this.skuEcodes = ''
        this.onRowData = ''
      } else {
        this.tableConfig2.current = 1
        this.onRowClickReplaceText = ''
        this.skuEcodes2 = ''
        this.onRowData2 = ''
      }
      this.search(val)
    },
    async search(value) {
      // const self = this
      // let data = {}
      // if (value == 'one') {
      //   data.skuEcode = self.tableConfig.businessFormConfig.formValue.searchValue.trim()
      //   data.spuEcode = self.tableConfig.businessFormConfig.formValue.psCProEcode.trim()
      //   data.spuEname = self.tableConfig.businessFormConfig.formValue.proName.trim()
      //   data.size = this.tableConfig.pageSize
      //   data.current = this.tableConfig.current
      // } else {
      //   data.skuEcode = self.tableConfig2.businessFormConfig.formValue.searchValue.trim()
      //   data.spuEcode = self.tableConfig2.businessFormConfig.formValue.psCProEcode.trim()
      //   data.spuEname = self.tableConfig2.businessFormConfig.formValue.proName.trim()
      //   data.size = this.tableConfig2.pageSize
      //   data.current = this.tableConfig2.current
      // }

      // this.service.commodityCenter.selectSkuProBySkuEcodeList(data).then((res) => {
      //   if (value == 'one') { //current
      //     this.tableConfig.current = res.data.data.current
      //     this.tableConfig.total = res.data.data.total
      //     this.tableConfig.data = res.data.data.records
      //   } else {
      //     this.tableConfig2.current = res.data.data.current
      //     this.tableConfig2.total = res.data.data.total
      //     this.tableConfig2.data = res.data.data.records
      //   }
      // })

      //console.log(self.replaceFormConfig.formValue.searchValue.trim())
      // sku查询
      const self = this
      const loadName = value === 'one' ? 'tableLoad' : 'replaceTableLoad'
      this[loadName] = true
      const query = {
        isBlur: 'N',
        psCSku: {
          ECODE:
            value == 'one'
              ? self.tableConfig.businessFormConfig.formValue.searchValue.trim()
              : self.tableConfig2.businessFormConfig.formValue.searchValue.trim(),
          psCProEcode:
            value == 'one'
              ? self.tableConfig.businessFormConfig.formValue.psCProEcode.trim()
              : self.tableConfig2.businessFormConfig.formValue.psCProEcode.trim(),
          psCProEname:
            value == 'one' ? self.proName.trim() : self.replace_proName.trim(),
        },
      }
      try {
        const res = await self.service.common.skuQuery(query)
        if (res.data.code == 0) {
          res.data.data.data.forEach((item, index) => {
            if (index == 0) {
              item._highlight = true
            }
            item.skuEcode = item.ECODE
            item.IS_GIFT = item.IS_GIFT == '0' ? t('否') : t('是')
          })
          if (value == 'one') {
            self.tableConfig.data = res.data.data.data
            self.onRowClickData =  self.tableConfig.data[0]
            self.onRowClickText =  self.tableConfig.data[0].ECODE
          } else {
            self.tableConfig2.data = res.data.data.data
            self.onRowClickReplaceData = self.tableConfig2.data[0]
            self.onRowClickReplaceText = self.tableConfig2.data[0].ECODE
          }
        } else {
          // this.$Message.warning("sku查询失败!");
          this.$Message.warning(t('sku查询失败'))
        }
        this[loadName] = false
      } catch (e) {
        this[loadName] = false
      }
    },
    async confirm() {
      // let orderList = []
      // let skuEcodes = []
      // this.componentData.a_2.forEach((em) => {
      //   let obj = {
      //     orderId: em.ID, //订单id
      //     billNo: em.BILL_NO, //单据编号
      //   }
      //   orderList.push(obj)
      // })
      // if (!this.onRowData || !this.onRowData2) {
      //   this.$Message.warning(t('请选择需要操作的单据！'))
      //   return
      // }
      // skuEcodes.push(this.onRowData.skuEcode)
      // skuEcodes.push(this.onRowData2.skuEcode)
      // let data = {
      //   skuEcodes,
      //   orderList,
      // }

      // this.service.orderCenter.replaceOrderByPro(data).then((res) => {
      //   if (res.data.code == 0) {
      //     this.$Message.success(res.data.message)
      //   } else {
      //     if (!res.data.data) {
      //       $utils.tipShow('error', self, res.data.message)
      //       return
      //     }
      //     this.$Modal.confirm({
      //       title: res.data.message,
      //       width: 500,
      //       mask: true,
      //       className: 'ark-dialog',
      //       render: (h) => {
      //         if (res.data.data) {
      //           return h('Table', {
      //             props: {
      //               columns: [
      //                 {
      //                   title: "单据编号", // '提示信息',
      //                   key: 'billNo',
      //                 },
      //                 {
      //                   title: t('提示信息'), // '提示信息',
      //                   key: 'message',
      //                 },
      //               ],
      //               data: res.data.data,
      //             },
      //           })
      //         }
      //         return false
      //       },
      //     })
      //   }
      //   this.$parent.$parent.closeConfirm()
      // })
      const self = this
      if (JSON.stringify(self.onRowClickData) == '{}') {
        // self.$Message.warning("替换前商品sku不能为空!");
        self.$Message.warning(t('替换前商品sku不能为空'))
        return
      }
      if (JSON.stringify(self.onRowClickReplaceData) == '{}') {
        // self.$Message.warning("替换后商品sku码不能为空!");
        self.$Message.warning(t('替换后商品sku码不能为空'))
        return
      }
      // if (self.onRowClickData.ECODE == self.onRowClickReplaceData.ECODE) {
      //   // self.$Message.warning("替换商品与被替换商品不能相同!");
      //   self.$Message.warning(t('替换商品与被替换商品不能相同'));
      //   return;
      // }
      const result = {}
      const needParam = {
        IS_GIFT:
          self.onRowClickReplaceData.IS_GIFT == t('是')
            ? '0'
            : '1',
        PS_C_PRO_ECODE: self.onRowClickReplaceData.PS_C_PRO_ECODE,
        PS_C_PRO_ENAME: self.onRowClickReplaceData.PS_C_PRO_ENAME,
        PRICELIST: self.onRowClickReplaceData.PRICELIST,
        IS_GROUP: self.onRowClickReplaceData.IS_GROUP,
        SKU_ECODE: self.onRowClickReplaceData.ECODE,
        PS_C_PRO_ID: self.onRowClickReplaceData.PS_C_PRO_ID,
      }
      if (self.componentData.a_2.length == 0) {
        // self.$Message.warning("请勾选订单数据!");
        self.$Message.warning(t('请勾选订单数据'))
        return
      }
      result.ids = self.componentData.a_2
      result.changeGoodsSku = self.onRowClickText // changeGoodsSku 这个是当前的 sku
      result.sku_code = self.onRowClickReplaceText // sku_code 这个是替换后的 sku
      result.type = 1
      console.log(this.componentData.a_1, result)
      $utils.setLoading(true)
      const {
        data: { code, data, message },
      } = await this.service.orderCenter.bathChangeGoods(result)
      $utils.setLoading()
      if (code == 0) {
        self.$Message.success(message)
        this.$parent.$parent.closeConfirm()
      } else {
        if (data instanceof Array && data.length) {
          self.$Modal.confirm({
            className: 'ark-dialog',
            title: message,
            mask: true,
            width: 500,
            render: (h) =>
              h('Table', {
                props: {
                  stripe: true,
                  border: true,
                  columns: [
                    {
                      title: t('序号'),
                      type: 'index'
                    },
                    {
                      title: t("错误信息"),
                      key: 'message',
                      align: 'center',
                      tdAlign: 'left'
                    },
                  ],
                  data,
                },
              }),
          })
        } else {
          self.$Modal.fcError(message)
        }
      }
    },
  },
}
